export default __webpack_public_path__ + "static/media/do-more-srce.6cca6626.png";